import { computed, Injectable, signal } from '@angular/core';
import { InfluencerStatsCampaign } from '../interfaces/influencer-stats.interface';

@Injectable({
  providedIn: 'root'
})
export class LandingPageStateService {
  clientAccountId = signal<string | null>(null);
  campaignId = signal<string | null>(null);
  campaignParticipantId = signal<string | null>(null);
  showLeaderboard = signal<boolean>(false);
  shareButtonText = signal<string>('Share Now');
  enableLeaderboard = signal(false);
  canViewConvertedCompanies = signal(false);
  canViewInfluencerStats = computed(() => this.canViewConvertedCompanies() || this.enableLeaderboard());

  reset(): void {
    this.clientAccountId.set(null);
    this.campaignId.set(null);
    this.campaignParticipantId.set(null);
    this.showLeaderboard.set(false);
    this.enableLeaderboard.set(false);
    this.canViewConvertedCompanies.set(false);
    this.shareButtonText.set('Share Now');
  }

  setCampaignContext(campaign: InfluencerStatsCampaign, participantId: string): void {
    if (this.clientAccountId() !== campaign.clientAccountId || this.campaignId() !== campaign.campaignId ||
        this.campaignParticipantId() !== participantId) this.showLeaderboard.set(false);
    this.clientAccountId.set(campaign.clientAccountId ?? null);
    this.campaignId.set(campaign.campaignId ?? null);
    this.campaignParticipantId.set(participantId || null);
    this.enableLeaderboard.set(campaign.enableLeaderboard === true);
    this.canViewConvertedCompanies.set(campaign.showConvertedCompanyNames === true && campaign.influencerInsightsAvailable === true);
    if (!this.canViewInfluencerStats()) this.showLeaderboard.set(false);
  }
}
